import AttributeDefinition from "../../domain/AttributeDefinition";

const ALWAYS_RENDERED_ATTRIBUTE_KEYS = new Set([
    "sealScore",
    "cvssBaseScore",
    "cveId",
    "rlsa",
    "fgIr",
    "ciscoSa",
]);

export function canRenderAttributeKey(key: string, definition?: AttributeDefinition): boolean {
    return ALWAYS_RENDERED_ATTRIBUTE_KEYS.has(key) || !!definition?.showTag;
}

export function canRenderAttributeValue(key: string, value: any, definition?: AttributeDefinition): boolean {
    if (value === undefined || value === null) {
        return false;
    }

    if (Array.isArray(value)) {
        return value.some(item => canRenderAttributeValue(key, item, definition));
    }

    return canRenderAttributeKey(key, definition);
}
